export class TypedEmitter {
    handlers = {};
    on(event, handler) {
        const set = this.handlers[event] ?? new Set();
        set.add(handler);
        this.handlers[event] = set;
        return () => {
            set.delete(handler);
        };
    }
    emit(event, payload) {
        const set = this.handlers[event];
        if (!set)
            return;
        for (const h of set)
            h(payload);
    }
    removeAllListeners() {
        this.handlers = {};
    }
}
//# sourceMappingURL=events.js.map